
export class Service {
  /*
   * From API
   */
  // public attendeesMax: number;
  // public attendeesMin: number;
  // public avatar: AvatarModel;
  // public cancellationPeriod: number;
  // public childrenVisibleOnLoad: boolean;
  // public color: string;
  // public created: string;
  //public discountPercentage: number;
  public duration: number;
  // public event: boolean;
  // public executionOrder: number;
  // public fixedInterval: boolean;
  // public hairLengthFilter: boolean;
  public id: number;
  // public longHair: boolean;
  // public ludaDefaultPrice: number;
  // public ludaPrice: number;
  // public ludaTaxonomyService: any;
  // public ludaTaxonomyServiceId: number;
  // public lvl: number;
  // public mediumHair: boolean;
  // public minimalPrice: any;
  public name: string;
  public nameTranslations: any;

  public shortDescription: string;
  
  // public newService: boolean;
  // public parentId: number;
  // public parentName: string;
  public pause1Start: number;
  // public provider: any;
  // public root: number;
  // public shortHair: boolean;
  public shortName: string;
  // public slug: string;
  // public specialOffer: boolean;
  // public status: number;
  // public updated: string;
  public serviceLink: string;

  public updated: string;

  public regularPrice1 : number;

  public slug: string;

  /*
  * Manually added
  */
  


  constructor(
    obj?: any
  ) {
    // console.log(obj);
    //this.discountPercentage = obj && obj.discountPercentage || 0;
    this.duration = obj && obj.duration || 0;
    this.id = obj && obj.id || null;
    this.name = obj && obj.name || null;
    this.nameTranslations = obj && obj.nameTranslations || null;
    this.pause1Start = obj && obj.pause1Start || 0;
    this.shortName = obj && obj.shortName || null;
    this.updated = obj && obj.updated || null;
    this.slug = obj && obj.slug || null;
    this.shortDescription = obj && obj.shortDescription || null;

    this.regularPrice1 = obj && obj.regularPrice1 || null;

    if (obj && obj._links && obj._links.self && obj._links.self.href) {
      this.serviceLink = obj._links.self.href || null;
    }

  }

}